<template>
    <div
        class="ui-input-checkbox"
        :class="[wrapperClass, { disabled: disabled }]"
    >
        <input
            :id="id"
            v-bind="$attrs"
            v-model="isChecked"
            type="checkbox"
            :value="value"
            :disabled="disabled"
            :aria-label="ariaLabel"
            class="checkbox-custom"
            @keydown.enter.prevent="toggleCheck"
        />
        <label :for="id"></label>
        <label :for="id"><slot /></label>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        wrapperClass: {
            type: [String, Object, Array],
            default: null
        },
        id: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: ''
        },
        value: {
            type: [Object, Array, String, Number, Boolean],
            default: false
        },
        checked: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        ariaLabel: {
            type: String,
            default: ''
        }
    },
    computed: {
        isChecked: {
            get: function () {
                return this.checked
            },
            set: function (value) {
                this.$emit('input', value)
            }
        }
    },
    methods: {
        toggleCheck() {
            if (this.disabled) return
            this.$emit('input', !this.checked)
        }
    }
}
</script>

<style lang="scss">
.ui-input-checkbox {
    display: flex;
    align-items: center;

    label {
        cursor: pointer;
    }

    &.disabled {
        display: none;
        &:hover {
            cursor: not-allowed;
        }

        label,
        input {
            opacity: 0.5;
            pointer-events: none;
        }
    }

    .checkbox-custom {
        & + label {
            min-width: rem(20px);
        }

        &:focus {
            & + label {
                @include n-theme() {
                    color: theme(color-primary);
                    border: 3px solid;
                }
            }
        }
        &:checked {
            & + label + label {
                font-weight: bold;

                @include n-theme() {
                    color: theme(color-primary);
                }
            }
        }
    }
}
</style>
